import { slugify } from 'lib/slugify'

export const validSharedFacet = ({
  sharedFacetNames,
  facetValue,
  facetName,
}: Record<string, any>): boolean => {
  // We need to SLUGIFY the Value
  const value = slugify(facetValue)
  // Skip items that SHARE Facet Values Ex: abstract: ['styles', 'subject'],
  // We will abstract for `styles`, but `subject` we will skip
  // EXIT, return if FIRST ITEM is !== FacetName
  return !(sharedFacetNames && sharedFacetNames[value] && sharedFacetNames[value][0] !== facetName)
}

export const getFirstFacetValue = (
  facetName: string,
  facetValues: Array<string>,
  options: Record<string, any>
): string => {
  const [facetValue] = facetValues || [] // Get First Item/Value

  if (facetName === 'has_prints') {
    return facetValue ? 'prints' : ''
  }

  if (facetName === 'category') {
    return facetValue || 'All'
  }

  const { sharedFacetNames, booleanFacetsObject } = options

  if (Object.keys(booleanFacetsObject).includes(facetName)) {
    return facetValue ? booleanFacetsObject[facetName] : ''
  }

  if (
    !validSharedFacet({
      sharedFacetNames,
      facetValue,
      facetName,
    })
  ) {
    return ''
  }

  return facetValue || ''
}

/*
Helper to remove values from Object
Used specifically for URL creation
Params ({
  facets: {category: [], styles: ['Abstract', 'Fine Art'], medium: ...},
  usedValues: { styles: 'Abstract'}
})
Will only return Values ( Non Emptry Arrays )
Result: {styles: ['Fine Art']}
pathParamBooleanFacetNameList: ['is_outdoor'] is an array of facetName to always remove from queryParams as this is going to be only a pathParam
*/
export const removeUsedFacets = ({
  facets,
  usedValues,
  pathParamBooleanFacetNameList,
}: Record<string, any>): Record<string, any> => {
  const facetResults = { ...facets }
  Object.entries(usedValues).forEach(([facetName, attributeValue]) => {
    if (attributeValue && facets[facetName] && facets[facetName].length) {
      if (Array.isArray(facets[facetName])) {
        facetResults[facetName] = facets[facetName].filter((i) => i !== attributeValue)
      } else if (facetResults[facetName] === attributeValue) {
        facetResults[facetName] = ''
      }
    }
    // Clear facets with only empty string values
    if (
      Array.isArray(facetResults[facetName]) &&
      facetResults[facetName].length === 1 &&
      facetResults[facetName][0] === ''
    ) {
      facetResults[facetName] = []
    }
  })

  // Clear all boolean facets that are path params to prevent duplicates in query string
  // This must happen after the loop to ensure all related boolean facets are cleared
  pathParamBooleanFacetNameList.forEach((facetName) => {
    facetResults[facetName] = []
  })

  return facetResults
}

export const convertSizeUnit = (userSizePreference) => {
  const multiplier = userSizePreference === 'cm' ? 2.54 : 1

  const geRoundNumber = (number) => {
    return Number(parseFloat(`${number * multiplier}`).toFixed(0))
  }

  return {
    small: `Small (<${geRoundNumber(20)} ${userSizePreference})`,
    medium: `Medium (${geRoundNumber(20)}-${geRoundNumber(38)} ${userSizePreference})`,
    large: `Large (${geRoundNumber(38)}-${geRoundNumber(60)} ${userSizePreference})`,
    oversized: `Oversized (>${geRoundNumber(60)} ${userSizePreference})`,
  }
}
